export default "__VITE_ASSET__DgBFCwhV__"